import { $authHost } from "../index"

// Робочі місця на лінії
export const checkWorkLinePlaceNowAPI = async () => {
    const {data} = await $authHost.post('api/work_line_place/now')
    return data
}

export const checkChangeWorkLinePlaceAPI = async ({ scaned }) => {
    const {data} = await $authHost.post('api/work_line_place/change/check', {scaned})
    return data
}

export const changeWorkLinePlaceAPI = async ({ scaned }) => {
    const {data} = await $authHost.post('api/work_line_place/change', {scaned})
    return data
}